module.exports = __webpack_public_path__ + "img/about_us_banner.471436e3.png";